import { useState } from "react";

import { formattedPlural } from "utilities/string/string";

import { BTButton } from "commonComponents/btWrappers/BTButton/BTButton";
import {
    BTConfirm,
    BTConfirmContent,
    BTConfirmFooter,
} from "commonComponents/btWrappers/BTConfirm/BTConfirm";
import { BTFormItem } from "commonComponents/btWrappers/BTForm/BTForm";
import { BTSelect } from "commonComponents/btWrappers/BTSelect/BTSelect";

import { type ApplyLienWaiverActions } from "entity/bill/BillList/ApplyLienWaiver/ApplyLienWaiver";
import { type ApplyLienWaiverResponse } from "entity/bill/BillList/BillList.api.types";

interface IApplyLienWaiverPresentationalProps {
    data: ApplyLienWaiverResponse;
    onClose: () => void;
    onApply: (selectedLienWaiverFormId: number) => void;
    actionBeingPerformed: ApplyLienWaiverActions;
}

export const ApplyLienWaiverPresentational: React.FunctionComponent<
    IApplyLienWaiverPresentationalProps
> = ({ data, onApply, onClose, actionBeingPerformed }) => {
    const [selectedLienWaiverFormId, setSelectedLienWaiverFormId] = useState(undefined);

    const title = `Apply lien waivers to ${data.eligibleBills.length} ${formattedPlural({
        value: data.eligibleBills.length,
        one: "item",
        other: "items",
    })}`;

    return (
        <BTConfirm visible title={title}>
            <BTConfirmContent>
                <BTFormItem label="Lien waiver template">
                    <BTSelect
                        id="lienWaiverTemplateId"
                        data-testid="lienWaiverTemplateId"
                        value={selectedLienWaiverFormId}
                        treeData={data.lienWaiverForms}
                        onChange={(field, value) => {
                            setSelectedLienWaiverFormId(value);
                        }}
                        onBlur={() => {}}
                    />
                </BTFormItem>
            </BTConfirmContent>
            <BTConfirmFooter>
                <BTButton
                    data-testid="cancel"
                    type="secondary"
                    onClick={onClose}
                    className="margin-right-xs"
                    actionBeingPerformed={actionBeingPerformed}
                    loadingAction="cancel"
                >
                    Cancel
                </BTButton>
                <BTButton
                    data-testid="apply"
                    onClick={() => onApply(selectedLienWaiverFormId!)}
                    disabled={selectedLienWaiverFormId === undefined}
                    actionBeingPerformed={actionBeingPerformed}
                    loadingAction="apply"
                    type="primary"
                >
                    Apply lien waivers
                </BTButton>
            </BTConfirmFooter>
        </BTConfirm>
    );
};
